const I = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KCjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDg1LjMzMyA1MTIgMzQxLjMzMyI+CjxyZWN0IHk9Ijg1LjMzMyIgZmlsbD0iI0ZGRkZGRiIgd2lkdGg9IjUxMiIgaGVpZ2h0PSIzNDEuMzMzIi8+CjxyZWN0IHk9Ijg1LjMzMyIgZmlsbD0iI0VFMDAwMCIgd2lkdGg9IjUxMiIgaGVpZ2h0PSIxNzAuNjY3Ii8+Cjwvc3ZnPgo=";
export {
  I as default
};
//# sourceMappingURL=ID-8c710ac6.mjs.map
